import apiCall from 'apps/investment/apiCalls/userProgram';
import { DetailPage, ListPage } from 'common/ui/AdminCRUD/page';
import { userProgramsColumns } from './config';
import ItemDetail from './detail';
import GoalPortfolio from './portfolio';

export const UserProgramListPage = (props, { params }) => {
  return (
    <ListPage
      enableSearch={true}
      title="All user goals"
      apiCall={apiCall}
      params={params}
      columnGenerator={props => userProgramsColumns(props)}
      resourceName="data"
      {...props}
    />
  );
};

export const UserProgramDetailPage = (props, { params }) => (
  <DetailPage
    title="Goal"
    listUrl={`/investment/user-programs`}
    apiCall={apiCall}
    ItemDetail={ItemDetail}
    params={params}
    resourceName="data"
    options={{ editEnabled: false }}
    {...props}
  />
);

export const UserProgramPortfolioPage = (props, { params }) => (
  <DetailPage
    title="Goal portfolio"
    pageTitle="View goal portfolio analytics"
    listUrl={`/investment/user-programs`}
    apiCall={apiCall}
    ItemDetail={GoalPortfolio}
    params={params}
    resourceName="data"
    options={{ editEnabled: false }}
    {...props}
  />
);
